import React from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import MenuIcon from '@material-ui/icons/Menu'
import { leftMenuItems } from '../../../constants'
import { makePath } from '../../../lib'
import { Word } from '../../../containers'
import { useContext } from 'react'
import { SettingsContext } from '../../Settings'

const styles = {
  list: {
    width: 250,
  },
  menuButton: {
    marginLeft: -11,
    marginRight: 20,
  },
  link: {
    textDecoration: 'none'
  }
}

const LeftMenuBar = (props) => {
  const { classes, open, handleOpen, handleClose } = props
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  return (
    <div>
      <IconButton className={classes.menuButton} color="inherit" onClick={handleOpen}>
        <MenuIcon />
      </IconButton>
      <Drawer open={open} onClose={handleClose}>
        <div
          tabIndex={0}
          role="button"
          onClick={handleClose}
          onKeyDown={handleClose}
        >
          <div className={classes.list}>
            <List>
              <ListItem button component={Link} to={makePath('/', language)}>
                <ListItemText primary="Renju Portal" />
              </ListItem>
            </List>
            <Divider/>
            {leftMenuItems.map((item, index) => {
              return (
                <List key={index}>
                  <ListItem button component={Link} to={makePath(item.to, language)} disabled={item.disabled}>
                    <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={<Word wid={item.wid}/>}/>
                  </ListItem>
                </List>
              )
            })}
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default withStyles(styles)(LeftMenuBar)


// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/components/LeftMenuBar.js